import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { api } from '@/lib/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/', { replace: true });
      return;
    }

    (async () => {
      try {
        const data = await api.exchangeSession(sessionId);
        if (data.session_token) {
          localStorage.setItem('session_token', data.session_token);
        }
        if (data.user) {
          setUser(data.user);
        }
        navigate('/dashboard', { replace: true, state: { user: data.user } });
      } catch {
        navigate('/', { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#FBFBFD] flex items-center justify-center">
      <div className="text-[#86868B] text-lg">Signing you in...</div>
    </div>
  );
}
